import axios from './axios';

export default {
  create(configuration) {
    return axios.post('/configurations', { configuration });
  },
  simulate(trunkConfiguration, options) {
    return axios.post('/trunk_configurations/simulate', {
      trunk: {
        trunk_configuration: trunkConfiguration,
        trunk_product: trunkConfiguration,
        trunk_options: options,
      },
    });
  },
  askQuote(trunkId, billlingAddress, siret) {
    return axios.post(`/trunk_configurations/${trunkId}/quote`, {
      billing_address: billlingAddress,
      siret,
    });
  },
  askSummary(trunkId) {
    return axios.get(`/trunk_configurations/${trunkId}/dossier_technique`);
  },
  shippingAvailable(trunkConfiguration) {
    return axios.post('/trunk_configurations/shipping_available', {
      trunk: {
        trunk_configuration: trunkConfiguration,
        trunk_product: trunkConfiguration,
      },
    });
  },
};
